<template>
    <div class="bg-dark text-light " style="min-height:100vh">
        <div class="container">
            <div class="d-flex justify-content-between align-items-center mb-3 border-bottom-1">
        <h5 style="text-align:center">کلمه ها</h5>
        <div class="btn-group">

            <router-link to="/addWord" class="btn btn-sm btn-success mt-2" style="border-radius:100%"><i class="fas fa-plus"></i></router-link>
        </div>
    </div>
    <div class="table-responsive">
        <div v-if="status != 'success'" class="text-center" style="min-height:100vh">
              <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>

        </div>
        <table v-else class="table table-striped table-bordered table-dark" style="text-align:center">
            <thead>
            <tr>
                <th>کلمه</th>
                <th>با اعراب</th>
                <th>آوا</th>
                <th>هجا</th>
                <th>تعداد</th>
                <th>تنظیمات</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(w , index) in words" v-bind:key="w.id" >
                    <td>{{w.word}}</td>
                    <td>{{w.fullWord}}</td>
                    <td><span v-for="a in w.ava" :key="a.index">{{a}} / </span></td>
                    <td><span v-for="h in w.heja" :key="h.index">{{h}} / </span></td>
                    <td>{{w.hejaCounter}}</td>
                    <td style="text-align:center">
                        <i class="fad fa-trash-alt text-primary" @click="remove(w.id , index)" style="cursor:pointer" ></i >
                    </td>

                </tr>

            </tbody>


        </table>
        
                        <div class="d-flex justify-content-center mt-4">
                    <ul class="pagination " style="text-align:center">
    <li class="page-item" :class="activePage == index ? 'active' : ''" v-for="index in pages" :key="index"
    @click="$router.push({query: {page : index}})"
    ><router-link class="page-link" to="/getWord">{{index}}</router-link></li>
  </ul>
            </div>
     
    </div>
    
    
     
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data(){
        return{
            words:[],
            pages:'',
            activePage:'',
            status:'waiting'
        }
    },
    methods:{
        async remove(id , index){
        let res = await axios.delete(`http://185.81.96.220/removeWord?api_token=${this.$store.getters.token}&id=${id}`)
        if(res.status == 200){
            this.words.splice(index , 1)
        }
        }
    },
    watch: {
    '$route.query': {
      async handler(query, oldQuery) {
          this.status="waiting"
          if(query != oldQuery){
        this.users = []
        let res = await axios.get(`http://185.81.96.220/getWord?api_token=${this.$store.getters.token}&page=${this.$route.query.page}`)
        if(res.status == 200){
                    this.words = res.data.words.docs
        this.pages = res.data.words.pages
        this.activePage = res.data.words.page
                this.status = "success"
        }
          
          }
      },
    },
    },
    async created(){
        this.status="waiting"
        let res = await axios.get(`http://185.81.96.220/getWord?api_token=${this.$store.getters.token}&page=${this.$route.query.page}`)
        if(res.status == 200){
                    this.words = res.data.words.docs
        this.pages = res.data.words.pages
        this.activePage = res.data.words.page
                this.status = "success"
        }

    }
}

</script>
<style  scoped>
table{
    color:white
}
</style>